const fe = (...r) => {
}, he = (r) => r.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), se = (r) => r !== null && r?.constructor.name === "Object", ye = (r) => typeof r == "string", S = (r, i) => {
  let y = r;
  const D = i.split(".");
  for (const L of D) {
    if (!se(y) || !(L in y))
      return "";
    y = y[L];
  }
  return `${y}`;
}, M = (r = "") => r.normalize("NFD").replace(/\p{Diacritic}/gu, ""), Q = (r, i) => {
  if (!r.length)
    return [];
  if (se(r[0])) {
    for (const y of r)
      if (!S(y, i))
        throw new Error("e03");
    return r;
  }
  return r.map((y) => ({
    [i]: ye(y) ? y : JSON.stringify(y)
  }));
}, ge = (r) => r.split(/\s+/), Re = async function(r, i) {
  const y = await fetch(
    r,
    i || {
      method: "GET"
    }
  );
  return $e(y);
}, $e = async function(r) {
  const i = await r.text(), y = i && JSON.parse(i);
  return r.ok ? y : Promise.reject(y && y.message || r.statusText);
}, me = {
  get: Re
}, He = (r = {}) => {
  const { hasDiacritics: i, tokenizer: y } = r;
  let D = {};
  const L = "\0";
  function z(a = "") {
    return a = `${a}`.trim(), i && (a = M(a)), (y || ge)(a.toLowerCase());
  }
  function I(a, E = "", x) {
    if (!a)
      return;
    let g;
    a = Array.isArray(a) ? a : [a];
    const m = ye(a[0]);
    for (const k of a) {
      const b = z(m ? k : S(k, E));
      for (const v of b) {
        if (!v)
          continue;
        g = D;
        for (const H of v)
          g = g[H] || (g[H] = {});
        const d = m ? k : x && x(k) || JSON.stringify(k), U = g[L] ?? (g[L] = {});
        U[d] = k;
      }
    }
  }
  function o(a) {
    let E = D;
    const x = {};
    for (const m of a)
      if (E = E?.[m], typeof E > "u")
        return {};
    const g = [{ node: E, prefix: a }];
    for (; g.length; ) {
      const { node: m, prefix: k } = g.pop();
      for (const b in m)
        if (b === L) {
          const v = m[L];
          for (const d in v)
            x[d] = v[d];
        } else
          g.push({ node: m[b], prefix: k + b });
    }
    return x;
  }
  const q = (a, E) => {
    const x = {};
    for (const g in a)
      g in E && (x[g] = a[g]);
    return x;
  };
  function R(a, E) {
    const x = z(a), g = x.length <= 20 ? x.length : 20;
    let m = o(x[0]);
    for (let b = 1; b < g && (m = q(m, o(x[b])), !!Object.keys(m).length); b++)
      ;
    m = Object.values(m);
    const k = m.length;
    return E && k > E && (m.length = E), {
      suggestions: m,
      count: k
    };
  }
  function j() {
    D = {};
  }
  return {
    add: I,
    clear: j,
    search: R
  };
}, Ie = (r) => {
  if (!r.input)
    throw new Error("e01");
  if (!se(r.source))
    throw new Error("e02");
  const i = document.createElement("div"), y = r.preventSubmit || !1, D = r.minLength || 1, L = r.hint !== !1, z = r.autoSelect || !1, I = r.tokenizer || ge, o = r.templates, q = Array.isArray(r.source.keys) ? r.source.keys : ["label"], R = r.source.groupKey || "", j = (e) => S(e, q[0]), a = r.display || j, E = r.source.identity || j, x = r.onSubmit || fe, g = r.source.transform || ((e) => e), m = r.source.local || null, k = typeof r.source.remote?.url, b = k === "function" || k === "string" && r.source.remote.wildcard ? r.source.remote : null, v = r.source.prefetch?.url ? { when: "onInit", done: !1, ...r.source.prefetch } : null, d = {
    wrapper: "typeahead-standalone",
    input: "tt-input",
    hint: "tt-hint",
    highlight: "tt-highlight",
    hide: "tt-hide",
    show: "tt-show",
    list: "tt-list",
    selected: "tt-selected",
    header: "tt-header",
    footer: "tt-footer",
    loader: "tt-loader",
    suggestion: "tt-suggestion",
    group: "tt-group",
    empty: "tt-empty",
    notFound: "tt-notFound",
    ...r.classNames || {}
  }, U = { block: "nearest", ...r.listScrollOptions || {} }, H = {
    updateHits: r.hooks?.updateHits || fe
  };
  if (!m && !v && !b)
    throw new Error("e02");
  const X = He({ hasDiacritics: r.diacritics, tokenizer: I }), $ = document.createElement("div");
  $.className = d.wrapper;
  const n = {
    query: "",
    hits: [],
    // suggestions
    count: 0,
    limit: r.limit || 5,
    wrapper: $
  };
  let P = {}, W = {}, p, Y, N = !1, B = "";
  o && (o.header = typeof o.header == "function" ? o.header : void 0, o.footer = typeof o.footer == "function" ? o.footer : void 0, o.notFound = typeof o.notFound == "function" ? o.notFound : void 0, o.group = typeof o.group == "function" ? o.group : void 0, o.suggestion = typeof o.suggestion == "function" ? o.suggestion : void 0, o.loader = typeof o.loader == "function" ? o.loader : void 0, o.empty = typeof o.empty == "function" ? o.empty : void 0);
  const J = (e = []) => {
    re(Q(e, q[0]));
  };
  m && J(m);
  const l = r.input;
  l.classList.add(d.input);
  const oe = window.getComputedStyle(l), V = l.parentNode, ve = [...V.children].indexOf(l);
  V.removeChild(l), $.appendChild(l), V.insertBefore($, V.children[ve]);
  const A = l.cloneNode(), be = /^(x-|hx-|data-|@)/;
  for (let e = A.attributes.length - 1; e >= 0; e--)
    be.test(A.attributes[e].name) && A.removeAttribute(A.attributes[e].name);
  L && Oe(A), i.classList.add(d.list, d.hide), i.setAttribute("aria-label", "menu-options"), i.setAttribute("role", "listbox"), i.style.position = "absolute", i.style.width = `${l.offsetWidth}px`, i.style.marginTop = `${l.offsetHeight + parseInt(oe.marginTop)}px`, new ResizeObserver((e) => {
    for (const t of e)
      i.style.width = `${t.target.offsetWidth}px`;
  }).observe(l), $.appendChild(i), v && v.when === "onInit" && ie();
  function ie() {
    if (!v || v.done)
      return;
    let e = [];
    me.get(typeof v.url == "function" ? v.url() : v.url, v?.requestOptions).then(
      (t) => {
        e = g(t), e = Q(e, q[0]), re(e);
      },
      (t) => {
        console.error("e04", t);
      }
    ).finally(() => {
      typeof v.process == "function" && v.process(e);
    }), v.done = !0;
  }
  const _ = () => {
    i.classList.remove(d.hide);
  }, we = () => {
    i.classList.add(d.hide);
  }, Ee = () => !i.classList.contains(d.hide) && !!Array.from(i.children).find((e) => e.classList.contains(d.suggestion)), ce = () => Y && clearTimeout(Y), O = () => {
    n.hits = [], A.value = "", B = "", we();
  }, le = () => {
    l.dispatchEvent(
      new InputEvent("input", {
        bubbles: !0,
        inputType: "insertCompositionText",
        data: l.value
      })
    );
  }, Z = (e = !1) => {
    if (!n.hits.length && n.query) {
      O(), ee();
      const t = o?.notFound?.(n);
      if (!t)
        return !0;
      const s = (u) => {
        const h = document.createElement("div");
        h.classList.add(d.notFound), F(h, u), i.appendChild(h);
      };
      return b ? (P[JSON.stringify(n.query)] || e && !N) && s(t) : s(t), _(), !0;
    }
  }, ee = () => {
    for (; i.firstChild; )
      i.firstChild.remove();
  }, te = (e = !0) => {
    if (!o?.loader)
      return;
    const t = i.querySelector(`.${d.loader}`);
    if (!e) {
      t && i.removeChild(t);
      return;
    }
    if (t)
      return;
    const s = document.createElement("div");
    s.classList.add(d.loader), F(s, o.loader()), o?.footer ? i.insertBefore(s, i.querySelector(`.${d.footer}`)) : i.appendChild(s), _();
  }, G = async () => {
    const e = await H.updateHits(
      {
        hits: n.hits,
        query: n.query,
        count: n.count
      },
      te
    );
    if (e?.hits?.length && (n.hits = e.hits, e.count && (n.count = e.count), e.updateSearchIndex && J(e.hits)), Z())
      return;
    ee();
    const t = (f) => {
      const c = document.createElement("div");
      return c.classList.add(d.suggestion), c.setAttribute("role", "option"), c.setAttribute("aria-selected", "false"), c.setAttribute("aria-label", a(f)), o?.suggestion ? F(c, o.suggestion(f, n)) : c.textContent = S(f, q[0]), c;
    }, s = (f) => {
      const c = document.createElement("div");
      return c.classList.add(d.group), c.setAttribute("role", "group"), c.setAttribute("aria-label", f), o?.group ? F(c, o.group(f, n)) : c.textContent = f || "", c;
    }, u = document.createDocumentFragment(), h = [];
    if (o?.header) {
      const f = document.createElement("div");
      f.classList.add(d.header), f.setAttribute("role", "presentation"), F(f, o.header(n)) && u.appendChild(f);
    }
    for (const [f, c] of n.hits.entries()) {
      if (f === n.limit)
        break;
      const w = S(c, R);
      if (w && !h.includes(w)) {
        h.push(w);
        const C = s(w);
        u.appendChild(C);
      }
      const T = t(c);
      T.addEventListener("click", (C) => {
        O(), p = c, l.value = a(c, C), le();
      }), c === p && (T.classList.add(d.selected), T.setAttribute("aria-selected", "true")), u.appendChild(T), r.highlight !== !1 && Ae(T, n.query);
    }
    if (o?.footer) {
      const f = document.createElement("div");
      f.classList.add(d.footer), f.setAttribute("role", "presentation"), F(f, o.footer(n)) && u.appendChild(f);
    }
    i.appendChild(u), L && De(p || n.hits[0]), i.querySelector(`.${d.selected}`)?.scrollIntoView(U), _();
  }, xe = (e) => {
    typeof e.inputType > "u" || e.inputType === "insertCompositionText" && !e.isComposing || (B = l.value, ae());
  }, ke = (e) => {
    const t = n.hits.length >= n.limit ? n.limit : n.hits.length;
    if (p === n.hits[0]) {
      p = void 0, l.value = B;
      return;
    }
    if (!p)
      p = n.hits[t - 1];
    else
      for (let s = t - 1; s > 0; s--)
        if (p === n.hits[s] || s === 1) {
          p = n.hits[s - 1];
          break;
        }
    l.value = a(p, e);
  }, Te = (e) => {
    const t = n.hits.length >= n.limit ? n.limit : n.hits.length;
    if (!p) {
      p = n.hits[0], l.value = a(p, e);
      return;
    }
    if (p === n.hits[t - 1]) {
      p = void 0, l.value = B;
      return;
    }
    for (let s = 0; s < t - 1; s++)
      if (p === n.hits[s]) {
        p = n.hits[s + 1];
        break;
      }
    l.value = a(p, e);
  }, Ce = (e) => {
    if (e.key === "Escape" || !l.value.length && !n.hits.length)
      return O();
    if (e.key === "Backspace" && (p = void 0), n.hits.length && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
      e.key === "ArrowDown" ? Te(e) : ke(e), G(), e.preventDefault(), e.stopPropagation();
      return;
    }
    if (!n.query && !l.value.length)
      return;
    const t = (s = !1) => {
      if (!p && s && n.hits.length && (p = n.hits[0]), p)
        return O(), l.value = a(p, e), le(), p;
    };
    if (e.key === "Enter") {
      y && e.preventDefault(), x(e, t());
      return;
    }
    e.key === "Tab" && Ee() && (r.retainFocus !== !1 && e.preventDefault(), t(!0));
  }, Le = () => {
    v?.when === "onFocus" && ie(), ae();
  }, ae = async () => {
    ce();
    const e = l.value.replace(/\s{2,}/g, " ").trim();
    if (o?.empty && !e.length) {
      const t = o.empty(n);
      if (n.query = "", Array.isArray(t) && t.length)
        return n.hits = Q(t, q[0]), await G();
      if (O(), ee(), t) {
        const s = document.createElement("div");
        s.classList.add(d.empty), F(s, `${t}`), i.appendChild(s);
      }
      return _();
    }
    if (e.length >= D) {
      n.query = e, ne();
      const t = JSON.stringify(n.query);
      b && n.hits.length < n.limit && W[t]?.length && ne(W[t]), G(), Y = setTimeout(() => {
        n.hits.length < n.limit && !N && de();
      }, b?.debounce || 200);
    } else
      n.query = "", O();
  }, ue = (e = "") => (r.diacritics && (e = M(e)), e.toLowerCase()), ne = (e) => {
    let { suggestions: t, count: s } = X.search(n.query, n.limit);
    if (e?.length) {
      e.push(...t);
      const u = {};
      for (const h of e)
        u[E(h)] = h;
      t = Object.values(u), s = t.length;
    }
    qe(t), R && Se(t), n.hits = t, n.count = s, p = void 0, z && n.hits.length && (p = n.hits[0]);
  }, de = () => {
    if (!b)
      return;
    N = !0;
    const e = n.query, t = JSON.stringify(e);
    if (P[t] || !n.query.length) {
      N = !1, Z(!0);
      return;
    }
    te(N);
    let s = [];
    me.get(
      typeof b.url == "function" ? b.url(e) : b.url.replace(b.wildcard, e),
      b.requestOptions
    ).then(
      (u) => {
        s = g(u), s = Q(s, q[0]), re(s);
      },
      (u) => {
        console.error("e05", u);
      }
    ).finally(() => {
      P[t] = !0, W[t] = s || [], N = !1, te(N), s.length && n.query.length && (ne(s), G()), n.query.length && e !== n.query && de(), Z(!0);
    });
  };
  function re(e) {
    if (e.length)
      for (const t of q)
        X.add(e, t, E);
  }
  const qe = (e) => {
    const t = n.query.toLowerCase();
    e.sort((s, u) => {
      const h = S(s, q[0]).toLowerCase(), f = S(u, q[0]).toLowerCase(), c = h.startsWith(t), w = f.startsWith(t);
      return c && w ? h.length - f.length : c ? -1 : w ? 1 : 0;
    });
  }, Se = (e) => {
    e.sort((t, s) => {
      const u = S(t, R), h = S(s, R);
      return !u && !h ? 0 : u ? h ? u < h ? -1 : u > h ? 1 : 0 : 1 : -1;
    });
  }, Ae = (e, t) => {
    if (!t)
      return;
    const u = ((c) => {
      const w = I(c.trim()).map((T) => he(T)).sort((T, C) => C.length - T.length);
      return new RegExp(`(${w.join("|")})`, "i");
    })(t), h = (c) => {
      let w = u.exec(c.data);
      if (r.diacritics && !w && (w = u.exec(M(c.data))), w) {
        const T = document.createElement("span");
        T.className = d.highlight;
        const C = c.splitText(w.index);
        return C.splitText(w[0].length), T.appendChild(C.cloneNode(!0)), c.parentNode?.replaceChild(T, C), !0;
      }
      return !1;
    }, f = (c, w) => {
      let C;
      for (let K = 0; K < c.childNodes.length; K++)
        C = c.childNodes[K], C.nodeType === 3 ? K += w(C) ? 1 : 0 : f(C, w);
    };
    f(e, h);
  };
  function Oe(e) {
    ["id", "name", "placeholder", "required", "aria-label"].forEach((t) => e.removeAttribute(t)), e.setAttribute("readonly", "true"), e.setAttribute("aria-hidden", "true"), e.style.marginTop = `-${l.offsetHeight + parseInt(oe.marginBottom)}px`, e.tabIndex = -1, e.className = d.hint, l.after(e);
  }
  const De = (e) => {
    const t = l.value;
    if (!t || a(e) === t || // if input string is exactly the same as selectedItem
    ue(a(e)).indexOf(
      ue(t).replace(/\s{2,}/g, " ").trimStart()
    ) !== 0)
      A.value = "";
    else {
      const s = a(e), u = new RegExp(he(n.query), "i");
      let h = u.exec(s);
      r.diacritics && !h && (h = u.exec(M(s))), h && (A.value = t.replace(/\s?$/, "") + s.substring(h[0].length));
    }
  }, F = (e, t) => {
    const s = document.createElement("template");
    return s.innerHTML = t, e.appendChild(s.content), t;
  }, Ne = () => {
    setTimeout(() => {
      document.activeElement !== l && O();
    }, 50);
  };
  i.addEventListener("mousedown", function(e) {
    e.stopPropagation(), e.preventDefault();
  });
  const pe = (e) => {
    O(), X.clear(), m && !e && J(m), P = {}, W = {}, v && (v.done = !1);
  }, Fe = () => {
    ce(), pe(), $.replaceWith(l.cloneNode());
  };
  return l.addEventListener("keydown", Ce), l.addEventListener("input", xe), l.addEventListener("blur", Ne), l.addEventListener("focus", Le), {
    addToIndex: J,
    reset: pe,
    destroy: Fe
    // trie, // trie exposed only for local tests
  };
};
export {
  Ie as default
};
